import React from 'react';

import styles from './style.scss';


const DashboardBannerEmpty = () => (
  <div className={styles.item}>
    <div className={styles.image} />
  </div>
);

export default DashboardBannerEmpty;
